export default {
  LOAD_COURSE (state, payload) {
    state.course = payload
  },
  LOAD_COURSE_TOPICS (state, payload) {
    if (payload.isState) {
      state.topics = []
    }
    state.topics = payload.data
  },
  LOAD_COURSE_LINEAR_TOPICS (state, payload) {
    if (payload.isState) {
      state.linearTopics = []
    }
    state.linearTopics = payload.data
  },
  LOAD_COURSE_TOPICS_MAP (state, payload) {
    if (payload.isState) {
      state.topicsMap = {}
    }
    state.topicsMap = payload.data
  },
  LOAD_CONTINUE_LEARNING (state, payload) {
    state.continueLearning = payload
  },
  LOAD_CONTINUE_LEARNING_LAST (state, payload) {
    state.continueLearningLast = payload
  },
  LOAD_COURSE_MICROCOMPETENCIES (state, payload) {
    state.microcompetencies = payload
  },
  LOAD_ENTITY_UUID (state, payload) {
    state.entityUuid = payload
  },
  LOAD_ENTITY_DETAIL (state, payload) {
    state.entity = payload
    // need to move these to computed properties on the view
    if (state.entity.objectType === 'LearningContent' && state.entity.fileType === 'video') {
      var yt = ''
      var uri = state.entity.uri
      if (uri.indexOf('v=') > 0 || uri.indexOf('embed') > 0) {
        yt = uri.substring(30)
      } else {
        yt = uri.substring(16)
      }
      state.entity.yt = yt
    }
    var iframeUrl = ''
    if (state.entity.objectType === 'LearningContent') {
      if (state.entity.fileType === 'pdf' || state.entity.fileType === 'doc' || state.entity.fileType === 'docx' || state.entity.fileType === 'pptx' || state.entity.fileType === 'ppt') {
        iframeUrl = 'https://drive.google.com/viewerng/viewer?url=' + state.entity.uri + '&embedded=true'
      } else {
        iframeUrl = state.entity.uri
      }
      state.entity.iframeUrl = iframeUrl
    }
  },
  LOAD_ENTITY_ACTIVITY (state, payload) {
    state.entityActivity = payload
  },
  LOAD_NEXT_ENTITY_DETAIL (state, payload) {
    if (payload.uuid === '') {
      var next = {
        'title': 'Congratulations!',
        'description': 'You have successfully attempted all the competencies',
        'fileType': 'assessment'
      }
      state.nextEntity = next
    } else {
      state.nextEntity = payload
      state.continueLearning = payload
    }
  },
  LOAD_MICRO_COMPETENCY_SUMMARY (state, payload) {
    state.mcSummary = payload
  },
  LOAD_MICRO_COMPETENCY_SUMMARY_FOR_SELECTED_USER (state, payload) {
    state.mcSummaryForSelectedUser = payload
  },
  LOAD_COMPETENCY_SUMMARY (state, payload) {
    state.competencySummary = payload
  },
  LOAD_COMPETENCY_SUMMARY_FOR_SELECTED_USER (state, payload) {
    state.competencySummaryForSelectedUser = payload
  },
  LOAD_CLASS_GRADE (state, payload) {
    state.classGrades = payload
  },
  LOAD_COURSE_COMPETENCIES (state, payload) {
    state.competencies = payload
  },
  LOAD_CLASS_SUMMARY (state, payload) {
    state.classSummary = payload
  },
  LOAD_FULL_CLASS_SUMMARY (state, payload) {
    state.fullClassSummary = payload
  },
  LOAD_CLASS_SUMMARY_WITH_PEER (state, payload) {
    state.classSummaryWithPeer = payload
  },
  LOAD_ENTITY_COMPETENCY (state, payload) {
    state.entityCompetency = payload
  },
  LOAD_CHILDREN_SUMMARY (state, payload) {
    state.childrenSummary = payload
  },
  LOAD_COMPETENCY_SUMMARY_FOR_CLASS (state, payload) {
    state.competencySummaryForClass = payload
  },
  LOAD_CHILDREN_COMPETENCY_SUMMARY_FOR_CLASS (state, payload) {
    state.childrenCompetencySummaryForClass = payload
  },
  LOAD_BLACKBOARD_COURSE_ACCESS (state, payload) {
    state.bbCourseAccess = payload
  },
  LOAD_BLACKBOARD_CONTENT_ACCESS (state, payload) {
    state.bbContentAccess = payload
  },
  LOAD_BLACKBOARD_GRADE_ACTIVITY (state, payload) {
    state.bbGradeActivity = payload
  },
  LOAD_BLACKBOARD_AGGREGATED_GRADE_ACTIVITY (state, payload) {
    state.bbAggregatedGradeActivity = payload
  },
  LOAD_BLACKBOARD_ANNOUNCEMENTS (state, payload) {
    state.bbAnnouncements = payload
  },
  LOAD_IS_TOC_OPEN (state, payload) {
    state.isTocOpen = payload
  }
}



// WEBPACK FOOTER //
// ./src/app/course/vuex/mutations.js